module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dark-section"
  }), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md dashboard"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "row gutter-xs items-center custom-space"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('span', {
    staticClass: "caption is-paper"
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.filter.dashboard')))])]), _vm._v(" "), (_vm.isRoot) ? _c('div', {
    staticClass: "col-xs-4 z-top",
    attrs: {
      "organizationId": _vm.organizationId
    }
  }, [_c('organization-filter', {
    attrs: {
      "organizationId": _vm.organizationId
    },
    on: {
      "change": _vm.onOrganizationChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 z-top"
  }, [_c('project-filter', {
    attrs: {
      "organizationId": _vm.organizationId
    },
    on: {
      "change": _vm.onProjectChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-auto z-top"
  }, [_c('period-filter', {
    on: {
      "change": _vm.onPeriodChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md m-bottom-base"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('leads-over-time-widget', {
    attrs: {
      "filter": _vm.filter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12"
  }, [_c('most-active-projects-widget', {
    attrs: {
      "filter": _vm.filter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12"
  }, [_c('conversion-funnel-widget', {
    attrs: {
      "filter": _vm.filter
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12 custom-padding-top"
  }, [_c('div', {
    staticClass: "row gutter-md sticky-column"
  }, [_c('div', {
    staticClass: "vertical-half reset-padding-top"
  }, [_c('latest-activity-widget', {
    staticClass: "panel-height",
    attrs: {
      "filter": _vm.filter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vertical-half reset-padding-top"
  }, [_c('kits-activity-widget', {
    staticClass: "panel-height",
    attrs: {
      "filter": _vm.filter
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f9324fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/Dashboard.vue
// module id = 1939
// module chunks = 0